module.exports = __webpack_public_path__ + "img/1-2.dae6a869.svg";